import React from 'react';
import PropTypes from 'prop-types';
import ActivismBlockInfo from '../../../02_molecules/ActivismBlockInfo';
import DefaultPicture, { propTypes as picturePropTypes } from '../../../01_atoms/DefaultPicture';
import {
  generateClassNameByBehaviorSettings,
  behaviorSettingsProps,
} from '../../../../utils/behaviorSettings';
import ProjectUsLogoIcon from '../../../../public/static/icons/logos/project-us.svg';
import CalendarIcon from '../../../../public/static/icons/calendar.svg';
import PeopleIcon from '../../../../public/static/icons/people.svg';
import LightbulbIcon from '../../../../public/static/icons/lightbulb.svg';

import styles from './index.module.scss';

const infoIcons = [
  {
    icon: <CalendarIcon className={styles['info__item_icon']} />,
    title: 'Workshop events',
  },
  {
    icon: <PeopleIcon className={styles['info__item_icon']} />,
    title: 'Workshop attendees',
  },
  {
    icon: <LightbulbIcon className={styles['info__item_icon']} />,
    title: 'Ideas generated',
  },
];

const BBActivismInfoWithIcons = ({
  heading = '',
  subheading = '',
  title = 'in numbers',
  image,
  items,
  behaviorSettings = null,
  uuid = null,
}) => (
  <div
    className={`bb ${styles['bb-activism-info-with-icons']} ${generateClassNameByBehaviorSettings(
      behaviorSettings,
    )}`}
    id={uuid}
  >
    <ActivismBlockInfo title={heading} subtitle={subheading} size="large" />
    <div className="container">
      <div className={styles['bb-activism-info-with-icons__content']}>
        <div className={styles['bb-activism-info-with-icons__info']}>
          <div className={styles['info__header']}>
            <ProjectUsLogoIcon className={styles['info__header_icon']} />
            <div className={styles['info__header_title']}>{title}</div>
          </div>
          <div className={styles['info__items']}>
            {items.map((item, index) => (
              <div className={styles['info__item']} key={`${item.number}-${index}`}>
                <div className={styles['info__item_icon_wrapper']}>{infoIcons[index].icon}</div>
                <div className={styles['info__item_text']}>
                  <div className={styles['info__item_number']}>{item.number}</div>
                  <div className={styles['info__item_title']}>{infoIcons[index].title}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <DefaultPicture
          {...image}
          loading="lazy"
          className={styles['bb-activism-info-with-icons__image']}
        />
      </div>
    </div>
  </div>
);

BBActivismInfoWithIcons.propTypes = {
  heading: PropTypes.string,
  subheading: PropTypes.string,
  title: PropTypes.string,
  image: PropTypes.shape(picturePropTypes).isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      number: PropTypes.number,
    }),
  ).isRequired,
  behaviorSettings: behaviorSettingsProps,
  uuid: PropTypes.string,
};

export default BBActivismInfoWithIcons;
